module.exports = __webpack_public_path__ + "img/ep3.fe39a887.jpg";